import Property from '@/services/Property/Property';
import * as types from '../mutation-types';
import Vue from 'vue';
import { forEach } from 'lodash';

// state
export const state = {
  live: null,
  sold: null,
  transferred: null,
  demolished: null,
  'under refurb': null,
  void: null,
  other: null,
};

// mutations
export const mutations = {
  [types.FETCH_PROPERTY_COUNTS_FAILURE](state) {
    state = {
      live: null,
      sold: null,
      transferred: null,
      demolished: null,
      'under refurb': null,
      void: null,
      other: null,
    };
  },

  [types.FETCHING_PROPERTY_COUNTS](state) {},

  [types.FETCH_PROPERTY_COUNTS_SUCCESS](state, counts) {
    forEach(state, (value, key) => {
      Vue.delete(state, key);
    });

    forEach(counts, (value, key) => {
      Vue.delete(state, key);
      Vue.set(state, key, value);
    });
  },

  [types.RESET_PROPERTY_COUNTS](state) {
    forEach(state, (value, key) => {
      Vue.delete(state, key);
    });
  },
};

// actions
export const actions = {
  /**
   * @param commit
   * @returns {Promise<void>}
   */
  async refreshPropertyCounts({ commit }) {
    commit(types.FETCHING_PROPERTY_COUNTS);

    try {
      const response = await Property.getCounts();
      commit(types.FETCH_PROPERTY_COUNTS_SUCCESS, response.data.counts);
    } catch (e) {
      commit(types.FETCH_PROPERTY_COUNTS_FAILURE);
    }
  },
};

// getters
export const getters = {
  propertyCount: state => status => state[status],
  propertyCounts: state => state,
};
